import { Navigate } from 'react-router-dom';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';
import { lazyRetry } from '@utils/lazyRetry';
import RequireAdmin from '../admin/settings/RequireAdmin';
import RequireCategory from '../admin/settings/RequireCategory';
import LegacyCaptureRedirect from './LegacyCaptureRedirect';

const CaptureApp = lazyRetry(() => import('./CaptureApp'));
const CaptureActivity = lazyRetry(() => import('./CaptureActivity'));
const CaptureExportDeliveries = lazyRetry(() => import('./CaptureExportDeliveries'));
const CaptureOperations = lazyRetry(() => import('./CaptureOperations'));
// Preserve old bookmarks while opening the corresponding workspace dialog.

/**
 * The Connect app routes.
 */
// The whole /connect surface needs the CAPTURE group
// permission, matching the nav filter in NavigationLoader. Super admins always pass.
const CaptureAppConfig: FuseRouteItemType = {
  path: 'connect',
  element: (
    <RequireCategory category="capture">
      <CaptureApp />
    </RequireCategory>
  ),
  children: [
    { path: 'activity', element: <CaptureActivity /> },
    { path: 'returns', element: <CaptureExportDeliveries /> },
    {
      path: '',
      element: <CaptureOperations />
    },
    {
      path: 'routing',
      element: <Navigate to="/connect?panel=settings" replace />
    },
    {
      path: 'pipeline',
      element: <Navigate to="/connect?panel=settings" replace />
    },
    {
      path: 'devices',
      element: (
        <RequireAdmin>
          <Navigate to="/connect?panel=setup" replace />
        </RequireAdmin>
      )
    },
    {
      path: ':chatId',
      element: <Navigate to="/connect" replace />
    }
  ]
};

export default [CaptureAppConfig, { path: 'capture/*', element: <LegacyCaptureRedirect /> }, { path: 'dispatch/*', element: <LegacyCaptureRedirect /> }] satisfies FuseRouteItemType[];
